import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MedicamentosComponent } from './pages/medicamentos/medicamentos.component';
import { LancamentoMedicamentoComponent } from './pages/medicamentos/lancamento-medicamento/lancamento-medicamento.component';
import { UsuarioComponent } from './pages/usuario/usuario.component';
import { UsuarioLancamentoComponent } from './pages/usuario/usuario-lancamento/usuario-lancamento.component';
import { AuthGuardService } from './guards/auth-guard.service';
import { LoginComponent } from './login/login.component';
import { InicioComponent } from './pages/inicio/inicio.component';
import { LaboratorioComponent } from './pages/laboratorio/laboratorio.component';
import { LancamentoLaboratorioComponent } from './pages/laboratorio/lancamento-laboratorio/lancamento-laboratorio.component';
import { AutorizadorComponent } from './pages/autorizador/autorizador.component';
import { LancamentoAutorizadorComponent } from './pages/autorizador/lancamento-autorizador/lancamento-autorizador.component';
import { ProgramaComponent } from './pages/programa/programa.component';
import { LancamentoProgramaComponent } from './pages/programa/lancamento-programa/lancamento-programa.component';
import { PaginaImportacaoExcelComponent } from './pages/medicamentos/pagina-importacao-excel/pagina-importacao-excel.component';
import { ConfiguracaoComponent } from './pages/configuracao/configuracao.component';
import { MensagemComponent } from './pages/mensagem/mensagem.component';
import { LancamentoMensagemComponent } from './pages/mensagem/lancamento-mensagem/lancamento-mensagem.component';
import { TokenComponent } from './pages/token/token.component';
import { TokenLancamentoComponent } from './pages/token/token-lancamento/token-lancamento.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AlteracaoSenhaComponent } from './reset-password/alteracao-senha/alteracao-senha.component';
import { LeadComponent } from './pages/lead/lead.component';
import { ListaExportacaoLeadComponent } from './pages/lead/lista-exportacao-lead/lista-exportacao-lead.component';
import { PesquisaComponent } from './pages/pesquisa/pesquisa.component';
const routes: Routes = [
  { path: 'inicio', component: InicioComponent, canActivate: [AuthGuardService] },

  { path: '', pathMatch: 'full', redirectTo: '/inicio' },

  { path: 'login', component: LoginComponent },
  { path: 'login/reset/password', component: ResetPasswordComponent },
  { path: 'login/reset/password/:token', component: AlteracaoSenhaComponent },

  //Tokens
  {path: 'tokens', component: TokenComponent, canActivate: [AuthGuardService]},
  {path: 'tokens/lancamento', component: TokenLancamentoComponent, canActivate: [AuthGuardService]},
  {path: 'tokens/lancamento/:id', component: TokenLancamentoComponent, canActivate: [AuthGuardService]},
  
  //Medicamento
  { path: 'medicamento', component: MedicamentosComponent, canActivate: [AuthGuardService] },
  { path: 'medicamento/cadastrar', component: LancamentoMedicamentoComponent, canActivate: [AuthGuardService] },
  { path: 'medicamento/cadastrar/:idmedicamento', component: LancamentoMedicamentoComponent, canActivate: [AuthGuardService]},
  { path: 'medicamento/importacao-excel', component: PaginaImportacaoExcelComponent, canActivate: [AuthGuardService]},

  //Pesquisas
  { path: 'pesquisa', component: PesquisaComponent, canActivate: [AuthGuardService]},
  
  //Laboratorio
  { path: 'laboratorio', component: LaboratorioComponent, canActivate: [AuthGuardService]  },
  { path: 'laboratorio/lancamento', component: LancamentoLaboratorioComponent, canActivate: [AuthGuardService] },
  { path: 'laboratorio/lancamento/:idlaboratorio', component: LancamentoLaboratorioComponent, canActivate: [AuthGuardService] },
  
  //Autorizador
  { path: 'autorizador', component: AutorizadorComponent, canActivate: [AuthGuardService]},
  { path: 'autorizador/lancamento', component: LancamentoAutorizadorComponent, canActivate: [AuthGuardService]},
  { path: 'autorizador/lancamento/:idautorizador', component: LancamentoAutorizadorComponent, canActivate: [AuthGuardService]},
  
  //Lead
  { path: 'lead', component: LeadComponent, canActivate: [AuthGuardService]},
  { path: 'lead/exportacao', component: ListaExportacaoLeadComponent, canActivate: [AuthGuardService]},
  
  //Programa
  { path: 'programa', component: ProgramaComponent, canActivate: [AuthGuardService]},
  { path: 'programa/lancamento', component: LancamentoProgramaComponent, canActivate: [AuthGuardService]},
  { path: 'programa/lancamento/:idprograma', component: LancamentoProgramaComponent, canActivate: [AuthGuardService]},
  
  //Usuario
  { path: 'usuario', component: UsuarioComponent, canActivate: [AuthGuardService] },
  { path: 'usuario/lancamento', component: UsuarioLancamentoComponent, canActivate: [AuthGuardService] },
  { path: 'usuario/lancamento/:id', component: UsuarioLancamentoComponent, canActivate: [AuthGuardService] },

  //Configuracao
  {path: 'configuracao', component: ConfiguracaoComponent, canActivate: [AuthGuardService]},
  
  //Mensagem
  {path: 'mensagem', component: MensagemComponent, canActivate: [AuthGuardService]},
  {path: 'mensagem/lancamento', component: LancamentoMensagemComponent, canActivate: [AuthGuardService]},
  {path: 'mensagem/lancamento/:idmensagem', component: LancamentoMensagemComponent, canActivate: [AuthGuardService]},
  { path: 'welcome', loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomeModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
